// @flow weak

import React      from 'react';
import PropTypes  from 'prop-types';

const UserPanel = (
  props
) => (
  <div className="user-panel">
    {
      // props.showUserPicture &&
      <div className="pull-left image">
        
      </div>
    }
    <div className="pull-left info">
    <p style={{textTransform:'capitalize', marginTop:'14px'}}>
       {props.hello} {props.username}
      </p>
    </div>
  </div>
);

UserPanel.propTypes = {
  hello:            PropTypes.string,
  username:         PropTypes.string,
  showUserPicture:  PropTypes.bool,
  userPicture:      PropTypes.any,
  connectionStatus: PropTypes.shape({
    online:         PropTypes.string,
    disconnected:   PropTypes.string
  }),
  online:           PropTypes.bool
};

UserPanel.defaultProps = {
  hello:    'Hello',
  username: 'Jane',
  connectionStatus: {
    online:       'Online',
    disconnected: 'Disconnected'
  },
  online:          false,
  showUserPicture: true
};

export default UserPanel;



// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/userPanel/UserPanel.js